import { render, staticRenderFns } from "./Adoptions.vue?vue&type=template&id=396b03ca&scoped=true"
import script from "./Adoptions.vue?vue&type=script&lang=js"
export * from "./Adoptions.vue?vue&type=script&lang=js"
import style0 from "./Adoptions.vue?vue&type=style&index=0&id=396b03ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b03ca",
  null
  
)

export default component.exports